import { useEffect, useState } from 'react'
import { Alert, Button, Col, Row } from 'react-bootstrap'
import { HeaderTitle } from '../../../../common/HeaderTitle'
import {Input, Radio, Select} from '../../../../common/inputs'
import { useUtworzProfil } from '../../../../../api/domain/profile/mutations/useUtworzProfil.jsx'
import { useProfil } from '../../../../../api/domain/profile/queries/useProfil.jsx'
import { useParams, useLocation } from 'react-router-dom'
import { useEdytujProfil } from '../../../../../api/domain/profile/mutations/useEdytujProfil.jsx'
import { useSelector } from 'react-redux'
import useCopyToClipboard from '../../../../../hooks/useCopyToClipboard.js'
import {optionsRodzajJednostki, optionsTypJednostki} from "../../../../utils/options.js";
import { useRegon } from '../../../../../api/domain/regon/queries/useRegon.jsx'
import {toast} from 'react-toastify'

const ViewProfilForm = () => {
    const titleName = 'Utwórz nowy / edytuj profil'
    const updateForm = (key, value) =>
        setForm((prevState) => ({ ...prevState, [key]: value }))
    const { id } = useParams()
    const location = useLocation()
    const tryb = location.pathname.includes('/podglad/') ? 'podglad' : 'edycja'
    const [errors, setErrors] = useState([])
    const role = useSelector((state) => state.user.role)
    const utworz = useUtworzProfil(setErrors)
    const zapisz = useEdytujProfil(setErrors)
    const func = tryb === 'edycja' && id !== 'nowy' ? zapisz : utworz
    const { data: profil, isPending } = useProfil(id)
    const [form, setForm] = useState({})
    const [value, copy] = useCopyToClipboard()
    const [regonChecked, setRegonChecked] = useState('')
    const [regonExists, setRegonExists] = useState(false)
    const [regonOwnerEmail, setRegonOwnerEmail] = useState('')
    const [regonLoading, setRegonLoading] = useState(false)
    const [typProfilu, setTypProfilu] = useState(
        profil?.symbol === 'D' ? 'departament' : (profil?.symbol ? 'jednostka' : 'departament')
    )
    const isReadOnly = role === 'wp' || tryb === 'podglad'

    const isDepartament = typProfilu === 'departament'
    const isCreating = id === 'nowy'
    const regonValue = form?.identyfikator || ''
    const regonTest = useRegon(regonValue, 'test')
    const regonData = useRegon(regonValue, 'data')

    const handleRegonTest = async () => {
        const regon = regonValue?.toString().trim()
        if (!regon) return
        setRegonLoading(true)
        const res = await regonTest.refetch()
        const data = res?.data

        if (data?.status === 'failed' && data?.list?.length) {
            setRegonChecked(regon)
            setRegonExists(true)
            setRegonOwnerEmail(data?.list?.[0]?.email_wlasciciela || '')
            setErrors((prev) => ({
                ...prev,
                identyfikator: undefined,
            }))
            toast.error(`Profil z tym REGON już istnieje${data?.list?.[0]?.email_wlasciciela ? ` (${data.list[0].email_wlasciciela})` : ''}.`)
        } else if (data?.errors) {
            setRegonChecked(regon)
            setRegonExists(false)
            setRegonOwnerEmail('')
            setErrors((prev) => ({
                ...prev,
                identyfikator: data?.errors?.regon || data?.errors?.identyfikator || data?.errors,
            }))
            toast.error("Numer REGON jest niepoprawny.")
        } else {
            setRegonChecked(regon)
            setRegonExists(false)
            setRegonOwnerEmail('')
            setErrors((prev) => ({
                ...prev,
                identyfikator: undefined,
            }))
            toast.success('REGON zweryfikowany pozytywnie.')
        }

        setRegonLoading(false)
    }

    const handleRegonFetch = async () => {
        const regon = regonValue?.toString().trim()
        if (!regon) return
        setRegonLoading(true)
        const res = await regonData.refetch()
        const data = res?.data

        if (data?.status === 'success' && data?.list?.length) {
            const item = data.list[0]
            updateForm('nazwa', item?.nazwa || '')
            setRegonChecked(regon)
            setRegonExists(false)
            setRegonOwnerEmail('')
        }

        setRegonLoading(false)
    }

    const validateDepartamentId = (value) => {
        if (!value) return null;
        if (value.length !== 3) return 'Kod musi mieć dokładnie 3 znaki.';
        if (!value.toUpperCase().startsWith('D')) {
            return 'Kod instytucji departamentu musi zaczynać się od litery "D".';
        }
        return null;
    }

    const handleRodzajProfiluChange = (value) => {
        setTypProfilu(value);
        if (value === 'jednostka') {
            updateForm('id', undefined);
        } else {
            updateForm('symbol', undefined);
        }
    }

    useEffect(() => {
        if (profil) setForm(profil)
    }, [profil, isPending])

    const allow = {
        show: {
            email: id === 'nowy',
            identyfikator: role === 'wp',
        },
        disable: {
            id: isPending || profil?.id,
            email: isPending || profil?.id,
        },
    }

    const isRegonRequired = isCreating ? !isDepartament : profil?.symbol !== 'D'
    const isRegonNotValidated = isRegonRequired && (
        !regonValue ||
        regonChecked !== regonValue ||
        regonExists ||
        Boolean(errors?.identyfikator)
    )

    return (
        <>
            <HeaderTitle
                breadcrumbLinks={[{ label: titleName }]}
                home
                nav
                destination={'/'}
                size={'fs-3'}
                title={titleName}
            />
            <div className={'d-flex flex-column p-3 gap-3 w-50'}>
                <Row>
                    <Col className={'d-flex flex-column justify-content-center gap-3'}>
                        <fieldset disabled={isReadOnly}>

                        {isCreating && (
                            <>
                                <Radio
                                    label={'Jaki typ jednostki?'}
                                    options={optionsTypJednostki}
                                    onChange={(e) => handleRodzajProfiluChange(e.target.value)}
                                    value={typProfilu}
                                />

                                {isDepartament ? (
                                    <Input
                                        limit={3}
                                        label={'Kod instytucji'}
                                        onChange={(e) => {
                                            const val = e.target.value.toUpperCase();
                                            const error = validateDepartamentId(val);
                                            updateForm('id', val);
                                            setErrors(prev => ({
                                                ...prev,
                                                id: error ? [error] : undefined
                                            }));
                                        }}
                                        value={form?.id}
                                        errorText={errors?.id}
                                    />
                                ):(
                                    <>
                                         <Select
                                            label={'Rodzaj jednostki'}
                                            options={optionsRodzajJednostki}
                                            onChange={(e) => updateForm('symbol', e.target.value)}
                                            value={form?.symbol}
                                         />

                                        <Input
                                            label={'REGON'}
                                            onChange={(e) => {
                                                updateForm('identyfikator', e.target.value)
                                                setRegonChecked('')
                                                setRegonExists(false)
                                                setRegonOwnerEmail('')
                                                setErrors((prev) => ({
                                                    ...prev,
                                                    identyfikator: undefined,
                                                }))
                                            }}
                                            value={form.identyfikator}
                                            errorText={errors.identyfikator}
                                        />
                                        <div className={'d-flex flex-column gap-2'}>
                                            <div className={'d-flex gap-2'}>
                                                <Button
                                                    size={'sm'}
                                                    variant={'info'}
                                                    disabled={regonLoading || !regonValue}
                                                    onClick={handleRegonTest}
                                                >
                                                    Sprawdź REGON
                                                </Button>
                                                <Button
                                                    size={'sm'}
                                                    variant={'secondary'}
                                                    disabled={
                                                        regonLoading ||
                                                        !regonValue ||
                                                        regonExists ||
                                                        regonChecked !== regonValue
                                                    }
                                                    onClick={handleRegonFetch}
                                                >
                                                    Pobierz z REGON
                                                </Button>
                                            </div>
                                        </div>
                                    </>
                                )}

                                <Input
                                    label={'Nazwa instytucji'}
                                    onChange={(e) => updateForm('nazwa', e.target.value)}
                                    value={form?.nazwa}
                                    errorText={errors?.nazwa}
                                />

                                <Input
                                    type={'email'}
                                    label={'Email osoby nadzorującej'}
                                    onChange={(e) =>
                                        updateForm('email', e.target.value)
                                    }
                                    value={form?.email}
                                    errorText={errors.email}
                                />

                                {form?.password && (
                                    <div className={'d-flex gap-2 align-items-center'}>
                                <span>
                                    Hasło do rejestracji konta dla instytucji:
                                </span>
                                        <Button
                                            size={'sm'}
                                            onClick={() =>
                                                copy(form.password)
                                            }
                                        >
                                            {value ===
                                            `${window.location.origin}/rejestracja/${form.id}`
                                                ? 'Skopiowano!'
                                                : 'Kopiuj link'}
                                        </Button>
                                    </div>
                                )}

                            </>
                        )}


                        {!isCreating && (
                            <>
                                <Input
                                    disabled={true}
                                    label={'Kod instytucji'}
                                    value={form?.id}
                                />
                                <Input
                                    disabled={isPending || tryb === 'podglad'}
                                    label={'Nazwa instytucji'}
                                    onChange={(e) => updateForm('nazwa', e.target.value)}
                                    value={form?.nazwa}
                                    errorText={errors?.nazwa}
                                />
                                <Input
                                    type={'email'}
                                    disabled={isPending || tryb === 'podglad'}
                                    label={'Email osoby nadzorującej'}
                                    onChange={(e) => updateForm('email', e.target.value)}
                                    value={form?.email}
                                    errorText={errors?.email}
                                />
                                {/*{profil?.symbol !== 'D' && (*/}
                                {/*    <>*/}
                                {/*        <Input*/}
                                {/*            label={'REGON'}*/}
                                {/*            onChange={(e) => {*/}
                                {/*                updateForm('identyfikator', e.target.value)*/}
                                {/*                setRegonChecked('')*/}
                                {/*                setRegonExists(false)*/}
                                {/*                setRegonOwnerEmail('')*/}
                                {/*                setErrors((prev) => ({*/}
                                {/*                    ...prev,*/}
                                {/*                    identyfikator: undefined,*/}
                                {/*                }))*/}
                                {/*            }}*/}
                                {/*            value={form.identyfikator}*/}
                                {/*            errorText={errors.identyfikator}*/}
                                {/*        />*/}
                                {/*        {!isReadOnly && (*/}
                                {/*        <div className={'d-flex flex-column gap-2'}>*/}
                                {/*            <div className={'d-flex gap-2'}>*/}
                                {/*                <Button*/}
                                {/*                    size={'sm'}*/}
                                {/*                    variant={'info'}*/}
                                {/*                    disabled={regonLoading || !regonValue}*/}
                                {/*                    onClick={handleRegonTest}*/}
                                {/*                >*/}
                                {/*                    Sprawdź REGON*/}
                                {/*                </Button>*/}
                                {/*            </div>*/}
                                {/*        </div>*/}
                                {/*        )}*/}
                                {/*    </>*/}
                                {/*)}*/}

                            </>
                        )}

                        </fieldset>

                    </Col>
                </Row>
                {!isReadOnly && (
                    <div className={'d-flex'}>
                        <Button
                            disabled={func.isPending}
                            className={'mt-2'}
                            onClick={() => func.mutate(form)}
                        >
                            {' '}
                            Zapisz profil
                        </Button>
                    </div>
                )}
            </div>

        </>
    )
}

export default ViewProfilForm
